export const pendingPaymentConstant = {
    PURCHASEHISTORY_REQUEST: 'PENDINGPAYMENT_REQUEST',
    PURCHASEHISTORY_REQUEST_SUCCESS: 'PENDINGPAYMENT_SUCCESS',
    PURCHASEHISTORY_FAILURE: 'PENDINGPAYMENT_FAILURE'
};